<template>
  <div :class="['menus', gid == 1 || gid == 2 ? '' : 'menus__other']">
    <div
      class="menu-list"
      :class="gid == 2 ? 'menu-list-disable' : ''"
      v-for="item in menuList"
      :key="item.id"
    >
      <router-link :to="gid == 2 ? '/auth/info' : item.url">
        <div
          class="menu"
          :class="$route.path == item.url ? 'active' : ''"
          v-if="item.id == '7' ? switchDoc : true"
        >
          <div class="iconbx">
            <i class="iconfont" :class="item.icon"></i>
          </div>
          <div class="title">{{ item.menu }}</div>
        </div>
      </router-link>
      <div
        class="sub-menu"
        v-for="subitem in item.submenu"
        :key="subitem.id"
        :class="$route.path == subitem.url ? 'active' : ''"
      >
        <template v-if="subitem.id == '7-1'">

          <router-link v-if="switchDoc" :to="gid == 2 ? '/auth/info' : subitem.url">
            <div class="title">
              <span>{{ subitem.title }}</span>
            </div>
          </router-link>

          
        </template>
        <template v-else-if="subitem.id == '6-1' || subitem.id == '6-2' || subitem.id == '6-3' || subitem.id == '6-4'">
          <router-link v-if="subitem.id == '6-1' && openArticle" :to="gid == 2 ? '/auth/info' : subitem.url">
            <div class="title">
              <span>{{ subitem.title }}</span>
            </div>
          </router-link>
          <router-link v-else-if="subitem.id == '6-2' && openArticle" :to="gid == 2 ? '/auth/info' : subitem.url">
            <div class="title">
              <span>{{ subitem.title }}</span>
            </div>
          </router-link>
          <router-link v-else-if="subitem.id == '6-3' && !openArticle" :to="gid == 2 ? '/auth/info' : subitem.url">
            <div class="title">
              <span>{{ subitem.title }}</span>
            </div>
          </router-link>
          <router-link v-else-if="subitem.id == '6-4' && switchs==1" :to="gid == 2 ? '/auth/info' : subitem.url">
            <div class="title">
              <span>{{ subitem.title }}</span>
            </div>
          </router-link>
        </template>
        <router-link v-else :to="gid == 2 ? '/auth/info' : subitem.url">
          <div class="title">
            <span v-if="subitem.id != '5-3' && sxLaw">{{ subitem.title }}</span>
            <span v-else-if="!sxLaw">{{ subitem.title }}</span>
            <span
              v-if="subitem.id == '2-6' && totalNum != 0 && totalNum != null"
              class="tips"
              >+{{ totalNum }}</span
            >
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getCookie } from "../assets/js/cookie";
import { lawtips, checkSwitchRight, checkOpenArticle,sxLawStatusApi,wendaIndex } from "../webapi/api";
import bus from "../assets/js/bus";
export default {
  name: "left-menu",
  props: {
    gid: {
      type: String,
    },
  },
  data() {
    return {
      menuList: [],
      consumerList: [
        { id: "1", menu: "个人首页", icon: "icona-06", url: "/consumer" },
        {
          id: "2",
          menu: "我的咨询",
          icon: "icona-07",
          url: "",
          submenu: [
            { id: "2-1", title: "免费咨询", url: "/consult/free" },
            { id: "2-2", title: "付费咨询", url: "/consult/pay" },
            { id: "2-3", title: "电话咨询", url: "/consult/telephone" },
            { id: "2-4", title: "一对一咨询", url: "/consult/onetoone" },
          ],
        },
        {
          id: "4",
          menu: "法律服务",
          icon: "icona-10",
          url: "",
          submenu: [
            { id: "4-1", title: "文书代写", url: "/user/paperwork/list" },
          ],
        },
        {
          id: "3",
          menu: "设置",
          icon: "icona-10",
          url: "",
          submenu: [
            { id: "3-1", title: "个人设置", url: "/user/info" },
            { id: "3-2", title: "账号与密码", url: "/user/account" },
          ],
        },
      ],
      lawyerList: [
        // 律师左边
        { id: "1", menu: "个人首页", icon: "iconzhuye", url: "/index" },
        {
          id: "2",
          menu: "咨询管理",
          icon: "icona-07",
          url: "",
          submenu: [
            { id: "2-1", title: "普通咨询", url: "/ask/common" },
            { id: "2-2", title: "付费咨询", url: "/ask/pay" },
            { id: "2-3", title: "一对一咨询", url: "/ask/onetoone" },
            { id: "2-4", title: "电话咨询", url: "/ask/telephone" },
            { id: "2-6", title: "新消息", url: "/ask/news" },
          ],
        },
        {
          id: "6",
          menu: "创作中心",
          icon: "icona-08",
          url: "",
          submenu: [
            { id: "6-1", title: "文章列表", url: "/article/list" },
            { id: "6-2", title: "发表文章", url: "/article/publish" },
            { id: "6-3", title: "开通专栏", url: "/article/open" },
            { id: "6-4", title: "百科问答", url: "/article/baike" },
          ],
        },
        {
          id: "7",
          menu: "法律服务",
          icon: "icon54",
          url: "",
          submenu: [{ id: "7-1", title: "文书代写", url: "/paperwork/list" }],
        },
        {
          id: "3",
          menu: "资金管理",
          icon: "icona-09",
          url: "",
          submenu: [
            { id: "3-1", title: "资金明细", url: "/money/capital" },
            { id: "3-2", title: "提现明细", url: "/money/cashout" },
          ],
        },
        { 
          id: "5", 
          menu: "资料管理", 
          icon: "icona-06", 
          url: "",
           submenu: [
            { id: "5-1", title: "个人资料", url: "/auth/infoname" },
            { id: "5-2", title: "律师认证", url: "/auth/info" },
            { id: "5-3", title: "年检认证", url: "/auth/annual" },
            { id: "5-4", title: "代表案例", url: "/auth/cases" },
          ],
        },
        {
          id: "4",
          menu: "设置",
          icon: "icona-10",
          url: "",
          submenu: [
            { id: "4-1", title: "咨询设置", url: "/set/askset" },
            { id: "4-2", title: "账号与密码", url: "/set/account" },
          ],
        },
      ],
      luid: null,
      totalNum: null, //总消息数
      switchDoc: false,
      openArticle: false,
      sxLaw:false,
      switchs:null,
    };
  },

  created() {
    this.luid = getCookie("uid");

    this.menuList =
      this.gid == 1 || this.gid == 2 ? this.lawyerList : this.consumerList;

    if (this.gid == 2) {
      if (this.$route.path != "/auth/info") {
        this.$router.push({ path: "/auth/info" });
      }
      return;
    }

    if (this.gid == 1) {
      // 律师
      this.getNews(); // 消息红点
      this.leftRight(); // 律师开关权限
      this.checkOpenArticle(); // 文章是否已开通
      this.sxLawStatusApi() //律师状态
      this.wenda()
    }
    //更新红点消息
    bus.$on("hidetips", () => {
      this.getNews();
    });

    // 更新左边导航
    bus.$on("update__left", () => {
      this.checkOpenArticle();
    });
  },

  methods: {
    //消息红点
    getNews() {
      this.$fetch
        .fetchData({
          url: lawtips,
        })
        .then((res) => {
          let { data } = res;
          let payNum = data.ff;
          let otoNum = data["1v1"];
          let doc = data.doc;
          let totalNum = payNum + otoNum + doc;
          this.totalNum = totalNum;
        })
        .catch((e) => {
          this.toast(e.errMsg || "请求错误");
        });
    },

    // 律师左边权限
    leftRight() {
      this.$fetch
        .fetchData({
          url: checkSwitchRight,
          data: {
            luid: this.luid,
          },
        })
        .then((res) => {
          let { switch_doc } = res.data;
          this.switchDoc = switch_doc == 0; // 0 是开 1 是关
        })
        .catch((e) => {
          this.toast(e.errMsg || "请求错误");
        });
    },
     
    // 律师百科权限 
    wenda() {
      this.$fetch
        .fetchData({
          url: wendaIndex,
        })
        .then((res) => {
          let { data } = res;
         this.switchs=data.switch
        })
        .catch((e) => {
          this.toast("error", e.errMsg || "请求错误");
        });
    },



    checkOpenArticle() {
      this.$fetch
        .fetchData({
          url: checkOpenArticle,
        })
        .then((res) => {
          let { data } = res || {};
          let { check } = data || {};
          this.openArticle = check == 1;
        })
        .catch((e) => {
          this.toast(e.errMsg || "请求错误");
        });
    },
    
    // 律师年检状态
    sxLawStatusApi(){
       this.$fetch
        .fetchData({
          url: sxLawStatusApi,
        })
        .then((res) => {
          let { data } = res;
          let {annual,status}=data
         this.sxLaw= annual==5 && status ==1
        })
        .catch((e) => {
          this.toast(e.errMsg || "请求错误");
        });
    },


    //消息提示
    toast(msg) {
      this.$message({
        type: "error",
        showClose: true,
        message: msg,
        offset: 50,
      });
    },
  },
};
</script>

<style scoped>
.menus {
  width: 212px;
  height: 1000px;
  background: #ffffff;
  border-radius: 3px;
  padding: 25px 30px 15px;
  box-sizing: border-box;
}

.menus__other {
  height: 504px;
}
.menus .menu-list {
  margin-bottom: 10px;
  float: left;
}
.menus .menu-list:first-child {
  margin-bottom: 20px;
}
.menus .menu {
  display: flex;
  align-items: center;
  line-height: 30px;
}
.menus .menu .iconbx {
  width: 30px;
}
.menus .menu .iconbx i {
  line-height: 30px;
  color: #a0a3af;
  font-size: 18px;
}
.menus .menu .title {
  font-size: 16px;
  color: #333;
}
.menus .sub-menu {
  padding-left: 30px;
  line-height: 40px;
}
.menus .sub-menu .title {
  font-size: 14px;
  color: #666;
}
.menus .sub-menu .tips {
  background-color: red;
  color: #fff;
  font-size: 12px;
  border-radius: 20px;
  padding: 2px 6px;
  margin-left: 10px;
}
.menus .menu-list-disable .title {
  opacity: 0.5;
}
.menus .active .title {
  color: #1476f9;
}
.menus .active .iconbx i {
  line-height: 30px;
  color: #1476f9;
}
</style>



// WEBPACK FOOTER //
// src/components/left.vue